import { css } from 'styled-components'

import error_image from 'components/Form/FormInput/_images/form_error.svg';
import { mobile_sizes } from 'app/Theme/mobile_sizes';

const ms = mobile_sizes();


const _tooltip_styles = css`
  .ant-tooltip {
    z-index: 1000 !important;
  }

  .ant-tooltip .ant-tooltip-inner {
    pointer-events: auto;
    min-height: 10px;
  }

  .ant-tooltip.subscription-tooltip {
    @media (min-width: ${p => p.theme.tabletSize}) {
      min-width: 448px;
    }
  }

  .ant-tooltip.event-settings-coping-tooltip {
    min-width: 348px;
  }
`;

const _collapsible_styles = css`
  .ant-collapse-item{
    background: transparent;
    border: none;
    border-top: 1px solid #DEDEE1;

    .ant-collapse-header:hover {
      background: ${p => p.theme.cPaleGray};
    }

    .ant-collapse-header {
      position: relative;
      font-weight: 600;
      color: ${p => p.theme.cDarkText}!important;
    }

    .ant-collapse-header:before {
      transition: all .32s ease-in-out;
      content: "";
      position: absolute;
      width: calc(100% - 12px);
      height: 1px;
      background-color: #DEDEE1;
      bottom: -1px;
      right: 0;
    }

    .ant-collapse-header-text {
      overflow: hidden;
    }
  }

  /* свойства перетаскиваемого объекта дополнительные */
  .sortable-collapse-helper.ant-collapse-item {
    z-index: 1;
    background: white;

    .ant-collapse-header {
      display: flex;
      justify-content: space-between;
      flex-direction: row-reverse;
      align-items: center;
      padding: 10px;
      line-height: 1.5333333333333334;
      font-size: 15px;
    }

    .ant-collapse-content-box {
      padding: 12px
    }
  }
`;

const _form_styles = css`
  .ant-form-item {
    padding: 0 20px;

    @media (min-width: ${p => p.theme.tabletSize}) {
      padding: 0 24px;
    }
  }

  .ant-form-item .ant-form-item-label {
    white-space: normal;
  }
`;

const _checkbox_styles = css`
  .ant-checkbox-wrapper {
    font-size: 14px;
  }
`;

const _input_number = css`
  .ant-input-number-group{
    border: 1px solid ${p => p.theme.input_border_color};
    border-radius: ${p => p.theme.borderRadius};
  }

  .ant-input-number-group .ant-input-number {
    border: none;
  }

  .ant-input-number-group .ant-input-number-group-addon {
    border: none;
    background: #FFFFFF;
    color: ${p => p.theme.input_placeholder_color};
    padding: 0;
    padding-right: 9px;
  }

  .ant-input-number-group-wrapper-status-error .ant-input-number-group {
    border: 1px solid ${p => p.theme.colorError};
    border-radius: 4px;

    .ant-input-number-status-error {
      border: none;
    }
  }

  .ant-input-number-group-wrapper-status-warning .ant-input-number-group {
    border: 1px solid ${p => p.theme.colorWarning};
    border-radius: 4px;

    .ant-input-number-status-warning {
      border: none;
    }
  }
`;

// красный треугольник в инвалидном инпуте
const _invalid_input = css`
  /* set colors */
  .ant-form-item-has-error,
  .ant-form-item-control-input:has([class*="status-error"]) {
    --error-color: ${p => p.theme.colorError};
  }

  .ant-form-item-has-warning,
  .ant-form-item-control-input:has([class*="status-warning"]) {
    --error-color: ${p => p.theme.colorWarning};
  }


  /* красная рамка вокруг радиогруппы */
  .ant-form-item-has-error .ant-radio-group.ant-radio-group-outline,
  .ant-form-item-has-warning .ant-radio-group.ant-radio-group-outline {
    border: 1px solid var(--error-color);
    border-radius: 4px;
    width: 100%;
  }


  /* красный треугольник в инвалидном инпуте */


  .ant-form-item-control-input:has([class*="status-warning"]),
  .ant-form-item-control-input:has([class*="status-error"]) {
    position: relative;

    & .ant-input-number {
      position: relative;
    }

    &:has(.ant-input-number) .ant-input-number:before,
    &:not(:has(.ant-input-number)):before {
      display: block;
      content: '';
      width: 12px;
      height: 12px;
      background-color: var(--error-color);
      mask: url(${error_image}) center center no-repeat;
      mask-size: contain;
      -webkit-mask: url(${error_image}) center center no-repeat;
      -webkit-mask-size: contain;
      position: absolute;
      right: 0;
      /* если сделать top: 50%, то во вложенных Form.Item с nostyle значок будет некрасиво съезжать вниз */
      top: 20px;
      transform: translate(-100%,calc(-50% - 1px));
      z-index: 5000;
    }

    .ant-input-number-group-addon {
      visibility: hidden;
    }

    .ant-input-affix-wrapper {
      padding-right 30px;
    }

    input[type="time"],
    input[type="date"] {
      padding-right: 30px;
    }
  }

  [class*="ant-form-item-explain"] {
    font-size: 10px;
  }
`;



const drawer_styles = css`
  /* чтобы сделать отступы, добавить в компонент Drawer rootClassName='drawer-with-margins-wrapper' */
  @media ${ms.tabletAndLargerMediaQuery} {
    .drawer-with-margins-wrapper {
      .ant-drawer-content-wrapper {
        margin: 50px 20px 20px 20px;

        .ant-drawer-content {
          border-radius: 4px;
        }
      }
    }
  }
`;

const _modal_styles = css`
/* z-index модалов должен быть 1000 - выше кнопки связаться с нами, у которой z-index: 777 */

  .ant-modal {
    .ant-modal-close {
      top: 17px;
      inset-inline-end: 15px;
      color: initial;

      @media (min-width: ${p => p.theme.tabletSize}) {
        top: 14px;
        width: 18px;
        height: 18px;
      }
    }
  }

  .ant-form-item-row {
    flex-direction: row;
    flex-wrap: nowrap;

    @media (min-width: ${p => p.theme.tabletSize}) {
      flex-wrap: wrap;
    }
  }

  @media (max-width: ${p => p.theme.tabletSize}) {
    .ant-form-item-label.ant-form-item-label-left {
      flex: 0 0 40% !important;
      width: 40% !important;
      max-width: 40% !important;
    }

    .ant-form-item-control {
      flex: 1 1 auto !important;
      max-width: 100% !important;
    }
  }


  .modal-event-participation-manual,.modal-event-participation {
    @media (max-width: ${p => p.theme.mobileLargeSize}) {
      max-width: 100% !important;
    }


    .ant-form-item-row {
      justify-content: flex-end;
    }

    .ant-form-item {
      padding: 0 20px;

      @media (min-width: ${p => p.theme.tabletSize}) {
        padding: 0 24px;
      }
    }

    @media (max-width: ${p => p.theme.tabletSize}) {
      .ant-form-item-label.ant-form-item-label-left {
        flex: 0 0 40% !important;
        width: 40% !important;
      }

      .ant-form-item-control {
        flex: 0 0 60% !important;
        width: 60% !important;
      }
    }
  }

  .ant-modal.modal-event-participation,
  .ant-modal.modal-event-participation-manual {
    top: 0;
    padding-bottom: 0;
    margin: 16px auto;

    .ant-modal-content { padding: 0; overflow: hidden; }
    .ant-modal-body { padding: 0 !important; min-height: 0; }
    .ant-modal-close {
      top: 6px;
      inset-inline-end: 8px;
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .ant-modal-close-x { display: flex; align-items: center; justify-content: center; }

    @media (max-width: 944px) {
      margin: 0;
      max-width: 100% !important;
      width: 100% !important;
      .ant-modal-content { border-radius: 0; }
    }
  }

  .modal-event-participation-manual {
    form > h1:first-child {
      display: flex;
      align-items: center;
      min-height: 56px;
      box-sizing: border-box;
      margin: 0;
      padding: 12px 60px 12px 20px;
    }
  }

  .ant-modal-top200 .ant-modal {
    top: 200px;
  }
`;

const _tabs = css`
  .ant-tabs-tab.ant-tabs-tab-active {
    border-left: 2px solid #F0F0F0;
    border-right: 2px solid #F0F0F0;
  }
`;

const _cascader = css`
  .ant-cascader-dropdown {
    border-radius: 0;
    box-shadow: none;
    font-size: 14px;
    font-weight: 400;
    line-height: 19.07px;
    color: ${p => p.theme.cDarkGreyText};
    background-color: transparent;
    overflow: visible;
    height: 1px;

    .ant-cascader-menu {
      position: relative;
      min-width: 200px;
      height: auto;
      background-color: #fff;
      box-shadow: 0 6px 16px 0 #00000014,
                  0 3px 6px -4px #0000001F;
      overflow: auto;
      max-height: 400px;
    }

    .ant-cascader-menu-item {
      border-radius: 0;
      padding: 10px 20px;
      border-bottom: 1px solid ${p => p.theme.filterBorderColor};
    }

    .ant-cascader-menu-item-disabled:first-child {
      position: sticky;
      top: 0;
      left: 0;
      right: 0;
      background-color: ${p => p.theme.cWhite};
    }

    .ant-cascader-checkbox {
      position: absolute;
      visibility: hidden;
      z-index: -1;
    }

    .ant-cascader-checkbox-checked + .ant-cascader-menu-item-content,
    .ant-cascader-checkbox-indeterminate + .ant-cascader-menu-item-content {
      color: ${p => p.theme.cBlue};
    }

    .ant-cascader-menu-item:not(.ant-cascader-menu-item-expand) .ant-cascader-checkbox-checked + .ant-cascader-menu-item-content::after {
      content: '';
      width: 13px;
      height: 10px;
      background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxMyAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjMzMzMzIDEwLjVMMCA2LjMzMzMzTDEuNzMzMzMgNC42NjY2N0w0LjMzMzMzIDcuMTY2NjdMMTEuMjY2NyAwLjVMMTMgMi4xNjY2N0w0LjMzMzMzIDEwLjVaIiBmaWxsPSIjMDNCMEY2Ii8+Cjwvc3ZnPgo=")
    }

    .ant-cascader-menu-item-content {
      display: flex;
      justify-content: space-between;
      gap: 10px;
      align-items: center;
      font-weight: 400;

      input {
        font-size: 14px;
        font-weight: 400;
        line-height: 19.07px;
        padding: 5px 10px;
      }
    }

    .ant-cascader-menu-item-active {
      background-color: ${p => p.theme.cHoverBlue};

      .ant-cascader-menu-item-content {
        font-weight: 400;
      }
    }

    &.ant-slide-up-leave {
      animation-duration: .05s !important;
    }
  }
`;

const _tag = css`
  .ant-tag {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    font-weight: 400;
    line-height: 19.07px;
    color: ${p => p.theme.cDarkGreyText};
    background-color: #A9C6E04D;
    border-radius: 18px;
    padding: 3px 8px;
    margin: 0;

    .ant-tag-close-icon {
      display: flex;
      margin-inline-start: 0;
    }
  }

  .ant-tag.checkable-tag {
    border: 1px solid ${p => p.theme.disabled_color};
    color: ${p => p.theme.cTextColor};
    padding: 6px 12px;
    background-color: transparent;
    transition: background-color .2s, color .2s;

    &.ant-tag-checkable-checked {
      background-color: #007BF5;
      color: ${p => p.theme.cWhite};
    }

    &.checkable-tag-disabled {
      opacity: .5;

      &:hover {
        background-color: transparent;
        color: ${p => p.theme.cDarkGreyText};
      }
    }
  }
`;

const _badge = css`
  .filter-active-count-badge.ant-badge {
    .ant-badge-count {
      min-width: 16px;
      height: 16px;
      font-size: 10px;
      line-height: 16px;
    }
  }
`;

const _drawer = css`
  .ant-drawer {
    .ant-drawer-content {
      border-radius: 8px 8px 0 0;
    }

    .ant-drawer-header {
      padding: 14px 20px;
      border-color: #DEDEE1;
    }

    .ant-drawer-body {
      padding: 0;
    }
  }
`;

const _dropdown = css`
  .ant-dropdown {
    z-index: 1000;
  }
`;

const _carousel = css`
  .ant-carousel .slick-arrow,
  .ant-carousel .slick-arrow:focus,
  .ant-carousel .slick-arrow:hover {
    width: 32px;
    height: 32px;
    right: 10px;
    border-radius: 100vw;
    border: 1px solid ${p => p.theme.cWhite};
    background-color: ${p => p.theme.disabled_color};
    color: ${p => p.theme.cDarkText};
  }

  .ant-carousel .slick-arrow::after {
    width: 9px;
    height: 9px;
    top: 10px;
    left: 9px;
  }

  .ant-carousel .slick-arrow.slick-prev::after {
    left: auto;
    right: 9px;
  }
`;

const _radio = css`
  .ant-radio-group.ant-radio-group-vertical {
    display: flex;
    flex-direction: column;
    gap: 15px;
    
    .ant-radio {
      margin-top: 3px;
      align-self: flex-start;
    }
  }
`;

export default css`
  ${_form_styles}
  ${_checkbox_styles}
  ${_tooltip_styles}
  ${_collapsible_styles}
  ${_input_number}
  ${_invalid_input}
  ${_tabs}
  ${_modal_styles}
  ${_cascader}
  ${_tag}
  ${_badge}
  ${_drawer}
  ${_dropdown}
  ${_carousel}
  ${_radio}
  ${drawer_styles}
`;
